import Camur from "./camurutils";
import Enums from "./enums";

const PS = Enums.protection_status;

export default {
  parameters_to_string(parameters) {
    var str = "?";
    while (parameters.length > 0) {
      var p = parameters.shift();
      str += p[0] + "=" + p[1];
      if (parameters.length > 0) str += "&";
    }
    return encodeURI(str);
  },

  get_xhr_response(xhr) {
    if (xhr != null && xhr.readyState == 4) {
      try {
        return JSON.parse(xhr.response);
      } catch (e) {
        if (e instanceof SyntaxError) {
          throw "Error parsing response: " + e;
        }
      }
    }
    return null;
  },

  svg_element_to_img_download(el, filename) {
    var svgString = new XMLSerializer().serializeToString(el);
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    ctx.canvas.height = el.clientHeight;
    ctx.canvas.width = el.clientWidth;

    var DOMURL = self.URL || self.webkitURL || self;
    var img = new Image();
    var svg = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    var url = DOMURL.createObjectURL(svg);

    let _this = this;

    img.onload = function() {
        // Skip first y-row because of a garbage dotted line !!?
      ctx.drawImage(img, 0, -1);
      var png = canvas.toDataURL("image/png");
      _this.download_data_as_file(png, filename + ".png");

      DOMURL.revokeObjectURL(png);
      canvas.remove();
    };
    img.src = url;
  },

  svg_element_download_as_file(el, filename) {
    var svgData = el.outerHTML;

    //add name spaces.
    if (!svgData.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
      svgData = svgData.replace(
        /^<svg/,
        '<svg xmlns="http://www.w3.org/2000/svg"'
      );
    }
    if (!svgData.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)) {
      svgData = svgData.replace(
        /^<svg/,
        '<svg xmlns:xlink="http://www.w3.org/1999/xlink"'
      );
    }

    this.download_blob_as_file(
      svgData,
      filename + ".svg",
      "image/svg+xml;charset=utf-8"
    );
  },

  download_data_as_file(data, filename) {
    var download = document.createElement("a");
    download.href = data;
    download.download = filename;
    download.click();
    download.remove();
  },

  download_blob_as_file(data, filename, type) {
    var blob = new Blob([data], { type: type });
    var url = URL.createObjectURL(blob);
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  },
  download_xlsx_as_file(data, filename) {
    var blob = new Blob([data]);
    var url = URL.createObjectURL(blob);
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  },

  //A-Za-z0-9 3-8 letters, cannot start with number
  alias_from_name(name) {
    name = name.toLowerCase();

    let legal_characters = "abcdefghijklmnopqrstuvwxyz0123456789";

    // Remove all illegal characters
    var alias = "";
    for (let i = 0; i < name.length; i++) {
      if (legal_characters.includes(name[i])) alias += name[i];
    }

    // If name is empty give it a timebased number
    if (alias.length == 0) {
      alias += Date.now();
    }

    // It cannot start with a number!
    if ("0123456789".includes(alias[0])) {
      alias = "a" + alias;
    }

    while (alias.length < 3 && alias.length > 0) {
      alias += alias;
    }
    alias = alias.substring(0, 8);

    return alias;
  },

  list_cntrls_for_project(proj, none_str) {
    var controllers = proj.cntrls;

    var result = [];
    for (var i = 0; i < controllers.length; i++) {
      result.push({
        id: controllers[i].id,
        title: controllers[i].name
      });
    }
    result.push({
      id: 0,
      title: none_str
    });

    return result;
  },

  is_array(value) {
    var res = value && typeof value === "object" && value.constructor === Array;
    return res;
  },

  is_object(value) {
    return value && typeof value === "object" && value.constructor === Object;
  },

  is_null(value) {
    return value === null;
  },

  is_node(item) {
    return item.item_type == "node";
  },

  is_zone(item) {
    return item.item_type == "zone";
  },

  is_cntrl(item) {
    return item.item_type == "cntrl";
  },

  is_project(item) {
    return item.item_type == "project";
  },

  is_cntrl_device(item) {
    return item.item_type == "cntrl_device";
  },

  is_node_device(item) {
    return item.item_type == "node_device";
  },

  deep_clone(src) {
    return this.iteration_copy(src);
  },

  iteration_copy(src) {
    if (this.is_array(src)) {
      let target = [];
      for (var i = 0; i < src.length; i++) {
        target.push(this.iteration_copy(src[i]));
      }
      return target;
    } else if (this.is_object(src)) {
      let target = {};
      for (let prop in src) {
        if (src.hasOwnProperty(prop)) {
          target[prop] = this.iteration_copy(src[prop]);
        }
      }
      return target;
    } else {
      return src;
    }
  },

  assign_template(obj, template) {
    for (var prop in template) {
      if (!obj.hasOwnProperty(prop)) {
        if (this.is_object(template[prop]) || this.is_array(template[prop])) {
          obj[prop] = this.iteration_copy(template[prop]);
        } else {
          obj[prop] = template[prop];
        }
      }
    }
  },

  diff_objects(old_object, changed_object) {
    var changes = {};
    for (var prop in old_object) {
      if (changed_object.hasOwnProperty(prop)) {
        if (
          this.is_object(old_object[prop]) ||
          this.is_array(old_object[prop])
        ) {
          var c = this.diff_objects(old_object[prop], changed_object[prop]);
          if (Object.keys(c).length > 0) changes[prop] = c;
        } else if (changed_object[prop] != old_object[prop]) {
          if (prop == "updated" || prop == "created") continue;
          changes[prop] = changed_object[prop];
        }
      }
    }
    return changes;
  },

  array_element_by_id(id, elements) {
    let existing_elements = elements.filter(el => {
      return el.id === id;
    });

    if (existing_elements.length == 1) {
      return existing_elements[0];
    } else if (existing_elements.length == 0) {
      return null;
    }
    throw "Multiple items in array had id " + id;
  },

  array_elements_mathing_prop(elements, prop_name, val) {
    return elements.filter(el => {
      return el.hasOwnProperty(prop_name) && el[prop_name] === val;
    });
  },

  update_object_in_array(obj_data, array_name, parent_object, template) {
    var array = parent_object[array_name];
    this.update_object(obj_data, array, template);
  },

  update_object(obj_data, array, template = null) {
    var object_to_update = this.array_element_by_id(obj_data.id, array);
    if (object_to_update != null) {
      object_to_update = Object.assign(object_to_update, obj_data);
    } else {
      if (template != null) this.assign_template(obj_data, template);
      array.push(obj_data);
    }
  },

  array_remove_object_with_id(array, id) {
    for (var i = 0; i < array.length; i++) {
      var uid = array[i].id;
      if (uid === id) {
        array.splice(i, 1);
        return;
      }
    }
  },

  array_remove_object_matching_prop(array, prop_name, prop_value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].hasOwnProperty(prop_name)) {
        var uid = array[i][prop_name];
        if (uid === prop_value) {
          array.splice(i, 1);
          return;
        }
      }
    }
  },

  remove_elements_not_present_in_new_array(old_array, new_array) {
    var ids_to_delete = [];

    for (var i = 0; i < old_array.length; i++) {
      if (this.array_element_by_id(old_array[i].id, new_array) === null) {
        ids_to_delete.push(old_array[i].id);
      }
    }

    for (var j = 0; j < ids_to_delete.length; j++) {
      this.array_remove_object_with_id(old_array, ids_to_delete[j]);
    }
  },

  //This function can find results when entering parts of the string.
  search_matches(name, pattern) {
    if (name == null || pattern == null) return false;
  
    name = name.trim().toLowerCase();
    pattern = pattern.trim().toLowerCase();
  
    // Return true if the name contains the pattern
    return name.includes(pattern);
  },

  // search_matches(name, pattern, contain_search = false) {
  //   if (name == null) return false;

  //   name = name.trim().toLowerCase();
  //   pattern = pattern.trim().toLowerCase();

  //   if (name.startsWith(pattern)) return true;

  //   let parts = name.split(" ");
  //   for (let part of parts) {
  //     if (contain_search) {
  //       if (part.includes(pattern)) return true;
  //     } else {
  //       if (part.startsWith(pattern)) return true;
  //     }
  //   }
  //   return false;
  // },

  //Makes the webpage laggy and crash from longer inputs
  // verify_email(email) {
  //   return /^\w+([.-]?[\w|+]+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(email);
  // },

  //Alot faster than above and doesnt make the email input lag
  verify_email(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  },

  to_iso_datetime(str) {
    if (!str) return false;
    var date = new Date(str);
    if (this.is_valid_date(date)) {
      return date.toISOString();
    }
    return false;
  },

  is_valid_date(d) {
    return d instanceof Date && !isNaN(d);
  },

  recording_is_inside_period(rec, period_start, period_end) {
    var period_start_time = new Date(period_start).getTime();
    var period_end_time = new Date(period_end).getTime();
    var rec_start_time = new Date(rec.start).getTime();
    var rec_end_date = new Date(Date.now());
    if (rec.stop != null) rec_end_date = new Date(rec.stop);

    var rec_end_time = rec_end_date.getTime();

    return (
      rec_end_time >= period_start_time && rec_start_time <= period_end_time
    );
  },

  make_date(year, month, day) {
    return new Date(year, month, day).toLocaleDateString("sv");
  },

  get_columns(pts) {
    var cols = [];
    for (var i = 0; i < pts.length; i++) {
      var keys = Object.keys(pts[i]);
      for (var j = 0; j < keys.length; j++) {
        if (!cols.includes(keys[j])) cols.push(keys[j]);
      }
    }
    return cols;
  },

  ordered_table(pts) {
    var rows = [];
    var columns = this.get_columns(pts);
    var last_dt = "";

    var tmplt_row = {
      Date: ""
    };
    for (let i = 1; i < columns.length; i++) {
      tmplt_row[columns[i]] = null;
    }

    for (let i = 0; i < pts.length; i++) {
      var date_key = "d" + new Date(pts[i].date).getTime();
      if (date_key != last_dt) {
        var row = this.deep_clone(tmplt_row);
        row.Date = pts[i].date;
        last_dt = date_key;
        rows.push(row);
      }
      for (var j = 0; j < columns.length; j++) {
        var key = columns[j];
        if (pts[i].hasOwnProperty(columns[j]) && key != "date") {
          rows[rows.length - 1][key] = pts[i][key];
        }
      }
    }
    return rows;
  },

  obj_array_to_array_array(obj_array) {
    return obj_array.map(function(obj) {
      return Object.keys(obj)
        .sort()
        .map(function(key) {
          return obj[key];
        });
    });
  },

  num_to_bytes(num) {
    num = parseInt(num);
    var byteArray = [0, 0, 0, 0];
    for (var index = 0; index < byteArray.length; index++) {
      var byte = num & 0xff;
      byteArray[index] = byte;
      num = (num - byte) / 256;
    }
    return String.fromCharCode(
      byteArray[0],
      byteArray[1],
      byteArray[2],
      byteArray[3]
    );
  },

  bytes_to_num(bytes_str) {
    var bytes = [];
    for (var i = 0; i < 4; i++) {
      bytes[i] = bytes_str.charCodeAt(i);
    }
    var result = bytes[0];
    result += bytes[1] << 8;
    result += bytes[2] << 16;
    result += bytes[3] << 24;
    return result;
  },

  bytes_to_base64(bytes) {
    return btoa(bytes);
  },
  base64_to_bytes(bytes) {
    return atob(bytes);
  },

  encode_serial_base64(serial) {
    return this.bytes_to_base64(this.num_to_bytes(serial));
  },

  decode_serial_base64(serial) {
    return this.bytes_to_num(this.base64_to_bytes(serial));
  },

  // eslint-disable-next-line
  download_xls(rows, filename) {
    alert("Not yet supported");
  },

  download_json(rows, filename) {
    let json_content =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(this.obj_array_to_array_array(rows)));
    this.download_file(json_content, filename + ".json");
  },

  download_csv(rows, filename) {
    let csv_content =
      "data:text/csv;charset=utf-8," +
      this.obj_array_to_array_array(rows)
        .map(e => e.join(","))
        .join("\n");
    this.download_file(encodeURI(csv_content), filename + ".csv");
  },

  download_file(content, filename) {
    var link = document.createElement("a");
    link.setAttribute("href", content);
    link.setAttribute("download", filename);
    document.body.appendChild(link); // Required for FF
    link.click();
  },

  filter_table(table, filter_string, filter_prop, contain_search = false) {
    if (filter_string == "") return table;
    return table.filter(e =>
      this.search_matches(e[filter_prop], filter_string, contain_search)
    );
  },

  is_string(val) {
    return typeof val === "string" || val instanceof String;
  },

  chance(percentage) {
    var d = Math.random() * 100.0 > percentage;
    return d;
  },

  rough_lowres_of_table(table, max_size) {
    let keep_ratio = max_size / table.length;
    let keep = [];
    for (var i = 0; i < table.length; i++) {
      if (keep.length / i < keep_ratio) {
        keep.push(table[i]);
      }
    }
    return keep;
  },

  // sort_table(table, sort_prop) {
  //   if (table.length == 0) return [];
  //   var sorted = this.deep_clone(table);
  //   if (
  //     sort_prop == "updated" ||
  //     sort_prop == "created" ||
  //     this.is_string(sorted[0][sort_prop])
  //   ) {
  //     return sorted.sort(function(a, b) {
  //       var _a = a[sort_prop];
  //       if (_a == null) _a = "";
  //       var _b = b[sort_prop];
  //       if (_b == null) _b = "";
  //       return _a.toUpperCase() < _b.toUpperCase() ? -1 : 1;
  //     });
  //   } else {
  //     return sorted.sort(function(a, b) {
  //       var _a = a[sort_prop];
  //       if (_a == null) _a = 0;
  //       var _b = b[sort_prop];
  //       if (_b == null) _b = 0;

  //       if (_a < _b) {
  //         return -1;
  //       }
  //       return 1;
  //     });
  //   }
  // },
  sort_table(table, sort_prop) {
    if (!table || table.length == 0) return [];

    // Special case: sort by locals.sortIndex (numeric)
    if (sort_prop === 'sortIndex') {
      var sorted = this.deep_clone(table);
      return sorted.sort(function (a, b) {
        var _a = (a && a.locals && typeof a.locals.sortIndex === 'number')
          ? a.locals.sortIndex : 0;
        var _b = (b && b.locals && typeof b.locals.sortIndex === 'number')
          ? b.locals.sortIndex : 0;

        if (_a < _b) return -1;
        return 1;
      });
    }

    // Original logic for everything else
    var sorted = this.deep_clone(table);
    if (
      sort_prop == "updated" ||
      sort_prop == "created" ||
      this.is_string(sorted[0][sort_prop])
    ) {
      return sorted.sort(function(a, b) {
        var _a = a[sort_prop];
        if (_a == null) _a = "";
        var _b = b[sort_prop];
        if (_b == null) _b = "";
        return _a.toUpperCase() < _b.toUpperCase() ? -1 : 1;
      });
    } else {
      return sorted.sort(function(a, b) {
        var _a = a[sort_prop];
        if (_a == null) _a = 0;
        var _b = b[sort_prop];
        if (_b == null) _b = 0;

        if (_a < _b) {
          return -1;
        }
        return 1;
      });
    }
  },
  formatDBSize(project) {
    let kb = Number(project?.dto?.dbSize ?? 0);

    if (kb < 1024) {
      return `${kb} KB`;
    }

    const mb = kb / 1024;
    if (mb < 1024) {
      return `${mb.toFixed(1)} MB`;
    }

    const gb = mb / 1024;
    return `${gb.toFixed(2)} GB`;
  },
  
  
  // THESE METHODS ARE ONLY NEEDED FOR FINDING 24H VALUE FROM DECAY RECORDINGS HISTORICALLY ----------------------

  // fetch_recording_infos(net, projectId, zoneId, cntrlId) {
  //   try {
  //     const to_date = new Date();
  //     const from_date = new Date();
  //     from_date.setFullYear(from_date.getFullYear() - 1);

  //     net.recording_info.list(
  //       projectId,
  //       zoneId,
  //       from_date,
  //       to_date,
  //       cntrlId,
  //       500,
  //       1
  //     );
  //   } catch {}
  // },


  // async fetch_decay_recording_for_lamps(project, zone, bar_chart_data_api) {
  //   let latest_decay_recording = null;
  //   try {
  //     for (let rec of zone.recording_infos) {
  //       if (rec.dto.type === 3) {
  //         if (!(new Date(rec.stop) > new Date(rec.start))) {
  //           continue;
  //         } else {
  //           latest_decay_recording = rec;
  //           break;
  //         }
  //       }
  //     }

  //     if (!latest_decay_recording) {
  //       console.log("No decay recording found");
  //       return null;
  //     }

  //     let channel_ids = [];
  //     for (let node of zone.nodes) {
  //       if (Camur.is_p_node(node.capability)) {
  //         for (let channelKey in node.channels) {
  //           let channel = node.channels[channelKey];
  //           channel_ids.push(channel.id);
  //         }
  //       }
  //     }

  //     const resp = await bar_chart_data_api.fetch(
  //       new Date(latest_decay_recording.start),
  //       new Date(latest_decay_recording.stop),
  //       96,
  //       project.id,
  //       null,
  //       channel_ids,
  //       {
  //         recordingId: latest_decay_recording.id,
  //         recordingType: Camur.recording_type.rectype_decay
  //       },
  //       false,
  //       true,
  //       1002
  //     );

  //     let fetched_decay_values = [];
  //     for (let serie of resp.series) {
  //       fetched_decay_values.push({channelId: serie.channelId, data: serie.data[serie.data.length-1]});
  //     }
  //     return { latest_decay_recording, fetched_decay_values };
  //   } catch {
  //     return null;
  //   }
  // },

  // find_decay_value(fetched_decay_values, channel) {
  //   if (!fetched_decay_values) return null;
  //   for (let ch of fetched_decay_values) {
  //     if (ch.channelId == channel.id) {
  //       if (ch.data[2]) {
  //         return ch.data[2]
  //       } else {
  //         return ch.data[3];
  //       }
  //     }
  //   }
  //   return null;
  // },
  // --------------------------------------------------------------------------------------------------

  format_decay_value(value) {
    if (value === null) return '-';
    return Math.round(value);
  },

  // Returns list of recording types included in the schedule
  get_schedule_included_items(cntrl) {
    let items = [];
    if (cntrl.decay_settings.includeSchedule) items.push('Decay');
    if (cntrl.lpr_settings.includeSchedule) items.push('LPR');
    if (cntrl.zra_settings.includeSchedule) items.push('ZRA');
    if (cntrl.resmes_settings.includeSchedule) items.push('ResMes');
    return items;
  },

  // Returns tooltip text listing all included schedule items
  get_schedule_tooltip(cntrl) {
    if (!cntrl.schedule.active) return 'Schedule is off';
    const items = this.get_schedule_included_items(cntrl);
    if (items.length === 0) return 'Schedule is active but no recording types are included';
    return 'Included: ' + items.join(', ');
  },

  // Returns short label for schedule column: "Off" or next item in schedule
  get_schedule_label(cntrl) {
    if (!cntrl.schedule.active) return 'Off';
    const items = this.get_schedule_included_items(cntrl);
    return items.join(', ');
  },

  protection_status_color(status) {
    switch (status) {
      case PS.good: return 'green';
      case PS.medium: return '#e6a817';
      case PS.low: return 'red';
      default: return 'gray';
    }
  },

  protection_status_text(status) {
    switch (status) {
      case PS.good: return 'Good';
      case PS.medium: return 'Warning';
      case PS.low: return 'Critical';
      default: return '-';
    }
  },

  format_depolarization_value(value) {
    if (value === null || value === undefined) return '-';
    return Math.round(value);
  },
  
  get_depolarization_compare_value(channel, zone) {
    if (!channel) return null;
    const compare_value = zone?.dto?.depolarizationCriteriaCompareValue;
    const has_max = channel.lastMaxDepolarizationValueUpdated > "2020-01-01";
    const has_last = channel.lastDepolarizationValueUpdated > "2020-01-01";
    if (compare_value == 1) {
      if (has_last) return channel.lastDepolarizationValue;
      return has_max ? channel.lastMaxDepolarizationValue : null;
    }
    if (has_max) return channel.lastMaxDepolarizationValue;
    return has_last ? channel.lastDepolarizationValue : null;
  },

  get_depolarization_status(value, zone) {
    if (value >= zone.dto.depolarizationCriteriaOk) return PS.good;
    if (value >= zone.dto.depolarizationCriteriaWarning) return PS.medium;
    return PS.low;
  },

  get_passive_reinforcement_status(value, zone) {
    if (value === null) return PS.none;
    if (value >= zone.dto.passiveCriteriaOk) return PS.good;
    if (value >= zone.dto.passiveCriteriaWarning) return PS.medium;
    return PS.low;
  },

  format_instant_off_value(value) {
    if (value === null || value === undefined) return '-';
    return Math.round(value);
  },

  get_instant_off_status(value, zone) {
    if (value === null || value === undefined) return PS.none;
    if (value <= zone.dto.instantOffPotentialCriteriaOk) return PS.good;
    return PS.low;
  },

  get_protection_grade(decayValue, depolarizationValue, instantOffPotential, zone) {
    const depol = depolarizationValue;
    const decay = decayValue;
    const io = instantOffPotential;
    const depolEnabled = zone.dto.depolarizationCriteriaEnable !== false;
    const passiveEnabled = zone.dto.passiveCriteriaEnable !== false;
    const instantOffEnabled = zone.dto.instantOffPotentialEnable !== false;
    if (
      (depolEnabled && depol >= zone.dto.depolarizationCriteriaOk) ||
      (passiveEnabled && decay !== null && decay >= zone.dto.passiveCriteriaOk) ||
      (instantOffEnabled && io !== null && io <= zone.dto.instantOffPotentialCriteriaOk)
    ) {
      return PS.good;
    }
    if (
      (depolEnabled && depol >= zone.dto.depolarizationCriteriaWarning) ||
      (passiveEnabled && decay !== null && decay >= zone.dto.passiveCriteriaWarning)
    ) {
      return PS.medium;
    }
    return PS.low;
  },

  // Returns the worst protection grade across all P channels in a zone
  get_zone_protection_grade(zone) {
    if (!zone || !zone.nodes) return PS.none;
    let hasMedium = false;
    for (let node of zone.nodes) {
      if (!Camur.is_p_node(node.capability)) continue;
      if (node.dto.serialNumber == null) continue;
      if (node.connected !== true) continue;
      for (let channelKey in node.channels) {
        let channel = node.channels[channelKey];
        // Skip non-visible and temperature channels
        if (!channel.userVisible) continue;
        if (!Camur.channelUsed(channel.no, node.capability, node.channelCount, false)) continue;
        const status = this.get_protection_grade(channel.lastDecayValue, this.get_depolarization_compare_value(channel, zone), channel.lastInstantOffPotentialValue, zone);
        if (status === PS.low) return PS.low;
        if (status === PS.medium) hasMedium = true;
      }
    }
    if (hasMedium) return PS.medium;
    return PS.good;
  },

  // Combined cathodic protection lamp for a zone
  // Checks: protection grade (decay), FixVolt output On, no alarms
  get_zone_cathodic_protection_lamp(zone, cntrl) {
    if (!zone || !zone.nodes || !cntrl) return PS.none;
    // Check all FixVolt outputs are On
    let hasFixVolt = false;
    let anyFixVoltOff = false;
    let anyFixVoltDisconnected = false;
    for (let node of zone.nodes) {
      if (node.is_power_supply && node.dto.serialNumber != null) {
        hasFixVolt = true;
        if (node.connected !== true) {
          anyFixVoltDisconnected = true;
        } else if (node.dto.psOutputOn !== true) {
          anyFixVoltOff = true;
        }
      }
    }

    // If any FixVolt is off → low
    if (hasFixVolt && anyFixVoltOff) return PS.low;

    // Check for alarms from any node
    if (zone.aggregateAlarmSignal) return PS.low;

    // Check for disconnected reference potential nodes
    let anyPNodeDisconnected = false;
    for (let node of zone.nodes) {
      if (Camur.is_p_node(node.capability) && node.dto.serialNumber != null && node.connected !== true) {
        anyPNodeDisconnected = true;
        break;
      }
    }

    // Check protection grade from decay values
    let grade = this.get_zone_protection_grade(zone);

    // Disconnected FixVolt or p-nodes cap result at medium, but never hide a worse grade
    if ((anyFixVoltDisconnected || anyPNodeDisconnected) && grade === PS.good) return PS.medium;

    // Schedule off caps the best possible result at medium,
    // but never hides a worse (low) grade
    if (!cntrl.schedule.active || !cntrl.decay_settings.includeSchedule) {
      if (grade === PS.good) return PS.medium;
      return grade;
    }

    return grade;
  },

  // Returns a tooltip listing all reasons the cathodic protection lamp is not green
  get_zone_cathodic_protection_tooltip(zone, cntrl) {
    if (!zone || !zone.nodes) return '';
    let reasons = [];

    // Check FixVolt
    let fixVoltTotal = 0;
    let fixVoltOff = [];
    let fixVoltDisconnected = [];
    for (let node of zone.nodes) {
      if (node.is_power_supply && node.dto.serialNumber != null) {
        fixVoltTotal++;
        if (node.connected !== true) {
          fixVoltDisconnected.push(node.name);
        } else if (node.dto.psOutputOn !== true) {
          fixVoltOff.push(node.name);
        }
      }
    }
    if (fixVoltTotal > 0 && (fixVoltOff.length > 0 || fixVoltDisconnected.length > 0)) {
      const onCount = fixVoltTotal - fixVoltOff.length - fixVoltDisconnected.length;
      let parts = [`Power: ${onCount}/${fixVoltTotal} ON`];
      if (fixVoltOff.length > 0) parts.push(`off: ${fixVoltOff.join(', ')}`);
      if (fixVoltDisconnected.length > 0) parts.push(`disconnected: ${fixVoltDisconnected.join(', ')}`);
      reasons.push(parts[0] + ' (' + parts.slice(1).join('; ') + ')');
    }

    // Check alarms
    if (zone.aggregateAlarmSignal) {
      let alarmNodes = [];
      for (let node of zone.nodes) {
        for (let key in node.channels) {
          let ch = node.channels[key];
          if (ch.alarmSignal) {
            alarmNodes.push(node.name + '-' + ch.name);
          }
        }
      }
      reasons.push('Alarm active: ' + (alarmNodes.length > 0 ? alarmNodes.join(', ') : 'Yes'));
    }

    // Check schedule
    if (!cntrl.schedule.active) {
      reasons.push('Schedule is off');
    } else if (!cntrl.decay_settings.includeSchedule) {
      reasons.push('Decay not included in schedule');
    }

    // Check for disconnected reference potential nodes
    let disconnectedPNodes = [];
    for (let node of zone.nodes) {
      if (Camur.is_p_node(node.capability) && node.dto.serialNumber != null && node.connected !== true) {
        disconnectedPNodes.push(node.name);
      }
    }
    if (disconnectedPNodes.length > 0) {
      reasons.push('Ref. potential disconnected: ' + disconnectedPNodes.join(', '));
    }

    // Check individual channel protection grades (connected nodes only)
    for (let node of zone.nodes) {
      if (!Camur.is_p_node(node.capability)) continue;
      if (node.dto.serialNumber == null) continue;
      if (node.connected !== true) continue;
      for (let channelKey in node.channels) {
        let channel = node.channels[channelKey];
        // Skip non-visible and temperature channels
        if (!channel.userVisible) continue;
        if (!Camur.channelUsed(channel.no, node.capability, node.channelCount, false)) continue;
        const status = this.get_protection_grade(channel.lastDecayValue, this.get_depolarization_compare_value(channel, zone), channel.lastInstantOffPotentialValue, zone);
        if (status === PS.low) {
          reasons.push(node.name + '-' + channel.name + ': Protection grade Low');
        } else if (status === PS.medium) {
          reasons.push(node.name + '-' + channel.name + ': Protection grade Medium');
        }
      }
    }

    if (reasons.length === 0) return 'All checks passed';
    return reasons.join('\n');
  },
};
